module.exports = __webpack_public_path__ + "static/media/export.2b0ef8e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/export.svg
// module id = 544
// module chunks = 0